import React, { Component } from 'react';
import { Layout, Card, Tag } from 'antd';
import styles from './index.module.less';
import SearchBar from '@/components/SearchBar';
import GFooter from '@/components/GlobalFooter';
import SiderMenu from '@/components/SiderMenu'

export default class NoticeLayout extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      currentRoute,
      sideType,
      children,
      menuData,
      titleName,
      setDocType,
      itemPath,
      setMenuItemKeyPath,
    } = this.props; 
    // 文档目录
    const docMenu = true;

    return (
      <Layout>
        <Layout className={styles.container}>
          <SiderMenu
            menuData={menuData}
            currentRoute={currentRoute}
            className={styles.siderMenu}
            isDocMenu={docMenu}
            setMenuItemKeyPath={setMenuItemKeyPath}
            setDocId={setDocType}
            titleName={titleName}
            style={{
              padding: '16px 0',
              width: '100%',
              borderRight: 'none'
            }}
            sideType={sideType}
          />
          {/* menu对应内容 */}
          <Layout.Content className={styles.content}>
            <div className={styles.breadcrumb}>{itemPath}</div>
            {children}
          </Layout.Content>
        </Layout>
        {/* 底部页脚区 */}
        <Layout.Footer className={styles.footer}>
            <GFooter></GFooter>
        </Layout.Footer >
      </Layout>
    )
  }
}